module.exports = __webpack_public_path__ + "static/media/edit_mixed_audio_detail.91391b9a.svg";